// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SobreNos_pageContainer__Q\\+Mx1 {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

.SobreNos_mainContent__DEu37 {
    flex: 1 1;
    padding: 0 15px;
}

.SobreNos_beliefsSection__mjeXC {
    margin: 40px 0;
    text-align: center;
}

.SobreNos_beliefsContainer__PvZYu {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 30px;
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
}

.SobreNos_beliefsItem__ZfqXY {
    background-color: #ffffff;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
    animation: SobreNos_fadeInUp__W\\+Cpi 0.5s ease forwards;
    opacity: 0;
    transform: translateY(20px);
}

@keyframes SobreNos_fadeInUp__W\\+Cpi {
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.SobreNos_beliefsItem__ZfqXY:hover {
    transform: translateY(-8px);
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
}

.SobreNos_cardLink__jM2PU {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 30px;
    text-decoration: none;
    color: inherit;
}

.SobreNos_cardIconWrapper__V6olG {
    background-color: #f8f9fa;
    width: 60px;
    height: 60px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 20px;
    transition: background-color 0.3s ease;
}

.SobreNos_beliefsItem__ZfqXY:hover .SobreNos_cardIconWrapper__V6olG {
    background-color: #e6392f;
}

.SobreNos_cardIcon__HdUc0 {
    width: 28px;
    height: 28px;
    object-fit: contain;
    transition: filter 0.3s ease;
}

.SobreNos_beliefsItem__ZfqXY:hover .SobreNos_cardIcon__HdUc0 {
    filter: brightness(0) invert(1);
    /* Torna o ícone branco quando hover */
}

.SobreNos_beliefsItem__ZfqXY h3 {
    font-size: 1.5rem;
    font-weight: 600;
    color: #1a1a1a;
    margin-bottom: 16px;
}

.SobreNos_beliefsItem__ZfqXY p {
    font-size: 1rem;
    color: #666;
    line-height: 1.6;
    margin-bottom: 24px;
    flex-grow: 1;
}

.SobreNos_cardFooter__2moOG {
    margin-top: auto;
}

.SobreNos_learnMore__owzDX {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: #e6392f;
    font-weight: 600;
    font-size: 1rem;
}

.SobreNos_arrowIcon__EgeiW {
    stroke: currentColor;
    transition: transform 0.3s ease;
}

.SobreNos_beliefsItem__ZfqXY:hover .SobreNos_arrowIcon__EgeiW {
    transform: translateX(5px);
}

/* Ajustes para dispositivos móveis */
@media (max-width: 768px) {
    .SobreNos_beliefsSection__mjeXC {
        margin: 30px 0;
    }

    .SobreNos_beliefsContainer__PvZYu {
        grid-template-columns: 1fr;
        padding: 10px;
        gap: 20px;
    }

    .SobreNos_cardLink__jM2PU {
        padding: 20px;
    }

    .SobreNos_beliefsItem__ZfqXY h3 {
        font-size: 1.4rem;
        margin-bottom: 12px;
    }

    .SobreNos_beliefsItem__ZfqXY p {
        font-size: 1.1rem;
        margin-bottom: 20px;
    }
}

@media (max-width: 480px) {
    .SobreNos_mainContent__DEu37 {
        padding: 0 10px;
    }

    .SobreNos_beliefsContainer__PvZYu {
        padding: 5px;
    }

    .SobreNos_beliefsItem__ZfqXY {
        border-radius: 12px;
    }

    .SobreNos_cardLink__jM2PU {
        padding: 15px;
    }

    .SobreNos_beliefsItem__ZfqXY h3 {
        font-size: 1.3rem;
        margin-bottom: 10px;
    }

    .SobreNos_beliefsItem__ZfqXY p {
        font-size: 1rem;
        line-height: 1.4;
        margin-bottom: 15px;
    }

    .SobreNos_cardIconWrapper__V6olG {
        width: 45px;
        height: 45px;
        margin-bottom: 15px;
    }

    .SobreNos_cardIcon__HdUc0 {
        width: 22px;
        height: 22px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/Site/SobreNos/SobreNos.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,SAAO;IACP,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,0CAA0C;IAC1C,yBAAyB;IACzB,uDAAsC;IACtC,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,+BAA+B;IAC/B,sCAAsC;AAC1C;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,+BAA+B;AACnC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,qCAAqC;AACrC;IACI;QACI,cAAc;IAClB;;IAEA;QACI,0BAA0B;QAC1B,aAAa;QACb,SAAS;IACb;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ","sourcesContent":[".pageContainer {\r\n    min-height: 100vh;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.mainContent {\r\n    flex: 1;\r\n    padding: 0 15px;\r\n}\r\n\r\n.beliefsSection {\r\n    margin: 40px 0;\r\n    text-align: center;\r\n}\r\n\r\n.beliefsContainer {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\r\n    gap: 30px;\r\n    max-width: 1200px;\r\n    margin: 0 auto;\r\n    padding: 20px;\r\n}\r\n\r\n.beliefsItem {\r\n    background-color: #ffffff;\r\n    border-radius: 16px;\r\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\r\n    transition: all 0.3s ease;\r\n    animation: fadeInUp 0.5s ease forwards;\r\n    opacity: 0;\r\n    transform: translateY(20px);\r\n}\r\n\r\n@keyframes fadeInUp {\r\n    to {\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n}\r\n\r\n.beliefsItem:hover {\r\n    transform: translateY(-8px);\r\n    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.cardLink {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100%;\r\n    padding: 30px;\r\n    text-decoration: none;\r\n    color: inherit;\r\n}\r\n\r\n.cardIconWrapper {\r\n    background-color: #f8f9fa;\r\n    width: 60px;\r\n    height: 60px;\r\n    border-radius: 12px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin: 0 auto 20px;\r\n    transition: background-color 0.3s ease;\r\n}\r\n\r\n.beliefsItem:hover .cardIconWrapper {\r\n    background-color: #e6392f;\r\n}\r\n\r\n.cardIcon {\r\n    width: 28px;\r\n    height: 28px;\r\n    object-fit: contain;\r\n    transition: filter 0.3s ease;\r\n}\r\n\r\n.beliefsItem:hover .cardIcon {\r\n    filter: brightness(0) invert(1);\r\n    /* Torna o ícone branco quando hover */\r\n}\r\n\r\n.beliefsItem h3 {\r\n    font-size: 1.5rem;\r\n    font-weight: 600;\r\n    color: #1a1a1a;\r\n    margin-bottom: 16px;\r\n}\r\n\r\n.beliefsItem p {\r\n    font-size: 1rem;\r\n    color: #666;\r\n    line-height: 1.6;\r\n    margin-bottom: 24px;\r\n    flex-grow: 1;\r\n}\r\n\r\n.cardFooter {\r\n    margin-top: auto;\r\n}\r\n\r\n.learnMore {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 8px;\r\n    color: #e6392f;\r\n    font-weight: 600;\r\n    font-size: 1rem;\r\n}\r\n\r\n.arrowIcon {\r\n    stroke: currentColor;\r\n    transition: transform 0.3s ease;\r\n}\r\n\r\n.beliefsItem:hover .arrowIcon {\r\n    transform: translateX(5px);\r\n}\r\n\r\n/* Ajustes para dispositivos móveis */\r\n@media (max-width: 768px) {\r\n    .beliefsSection {\r\n        margin: 30px 0;\r\n    }\r\n\r\n    .beliefsContainer {\r\n        grid-template-columns: 1fr;\r\n        padding: 10px;\r\n        gap: 20px;\r\n    }\r\n\r\n    .cardLink {\r\n        padding: 20px;\r\n    }\r\n\r\n    .beliefsItem h3 {\r\n        font-size: 1.4rem;\r\n        margin-bottom: 12px;\r\n    }\r\n\r\n    .beliefsItem p {\r\n        font-size: 1.1rem;\r\n        margin-bottom: 20px;\r\n    }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    .mainContent {\r\n        padding: 0 10px;\r\n    }\r\n\r\n    .beliefsContainer {\r\n        padding: 5px;\r\n    }\r\n\r\n    .beliefsItem {\r\n        border-radius: 12px;\r\n    }\r\n\r\n    .cardLink {\r\n        padding: 15px;\r\n    }\r\n\r\n    .beliefsItem h3 {\r\n        font-size: 1.3rem;\r\n        margin-bottom: 10px;\r\n    }\r\n\r\n    .beliefsItem p {\r\n        font-size: 1rem;\r\n        line-height: 1.4;\r\n        margin-bottom: 15px;\r\n    }\r\n\r\n    .cardIconWrapper {\r\n        width: 45px;\r\n        height: 45px;\r\n        margin-bottom: 15px;\r\n    }\r\n\r\n    .cardIcon {\r\n        width: 22px;\r\n        height: 22px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageContainer": `SobreNos_pageContainer__Q+Mx1`,
	"mainContent": `SobreNos_mainContent__DEu37`,
	"beliefsSection": `SobreNos_beliefsSection__mjeXC`,
	"beliefsContainer": `SobreNos_beliefsContainer__PvZYu`,
	"beliefsItem": `SobreNos_beliefsItem__ZfqXY`,
	"fadeInUp": `SobreNos_fadeInUp__W+Cpi`,
	"cardLink": `SobreNos_cardLink__jM2PU`,
	"cardIconWrapper": `SobreNos_cardIconWrapper__V6olG`,
	"cardIcon": `SobreNos_cardIcon__HdUc0`,
	"cardFooter": `SobreNos_cardFooter__2moOG`,
	"learnMore": `SobreNos_learnMore__owzDX`,
	"arrowIcon": `SobreNos_arrowIcon__EgeiW`
};
export default ___CSS_LOADER_EXPORT___;
